import { z } from 'zod'
import { baseClientDetailSchema } from '../clients/clients.schema'

type EmailCheckIn = z.infer<typeof emailCheckInSchema>

const checkedInClientSchema = z.object({
  client: baseClientDetailSchema.nullable(),
})

const emailCheckInSchema = z.object({
  email: z
    .string()
    .trim()
    .toLowerCase()
    .email({ message: 'Please enter a valid email.' }),
})

export type { EmailCheckIn }
export { checkedInClientSchema, emailCheckInSchema }
